class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// 2026-10-30 (auditoria R2-03/T6): busca por código de peça digitado com espaços, pontos ou hífens
// ("80 14 5 A87 961" -> "80145A87961"). Só quando todas as partes têm número e o código junto tem 8+ caracteres;
// frases normais ("capacete gs 2024", "R 1300 GS") não mudam.
window.evNormalizarBuscaCodigo = function (consulta) {
  const s = String(consulta || '').trim();
  if (!/^[0-9A-Za-z][0-9A-Za-z .\-]*$/.test(s)) return s;
  const partes = s.split(/[ .\-]+/).filter(Boolean);
  if (partes.length < 2 || !partes.every((p) => /\d/.test(p))) return s;
  const junto = partes.join('');
  return junto.length >= 8 ? junto : s;
};

document.addEventListener(
  'submit',
  function (event) {
    const form = event.target;
    if (!form || !form.querySelector) return;
    const acao = form.getAttribute('action') || '';
    if (!/\/search(\?|$)/.test(acao)) return;
    const campo = form.querySelector('input[name="q"]');
    if (campo) campo.value = window.evNormalizarBuscaCodigo(campo.value);
  },
  true
);
